<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <v-form ref="form">
                    <v-container py-0>
                        <v-layout wrap>            
                            <v-flex xs12 md12>
                                <v-text-field :readonly="true" :label="labelDocumento" 
                                    required :rules="rules.documento" v-model.trim="documento"
                                    v-mask="mascaraDocumento"/>
                            </v-flex> 

                            <v-flex xs12 md12>
                                <v-text-field :readonly="value.indicadorAprovado" :label="labelPrimeiroNome" @change="txtPrimeiroNome_OnChange"
                                    required :rules="rules.primeiroNome" v-model.trim="primeiroNome"/>
                            </v-flex>           

                            <v-flex xs12 md12>
                                <v-text-field :readonly="value.indicadorAprovado" :label="labelUltimoNome" @change="txtUltimoNome_OnChange"
                                    required :rules="rules.ultimoNome" v-model.trim="ultimoNome"/>
                            </v-flex>       
                        </v-layout>
                    </v-container>         
                </v-form>                  
            </v-flex>            
        </v-layout>               
    </v-container>
</template>

<script>
import DocumentoMixin from '@/mixin/documento'
import FormMixin from '@/mixin/form'
import StepMixin from './mixin'

import { mask }  from 'vue-the-mask'
import OnboardingConstantes from '@/constants/onboarding/parametrizacao'

export default {
    mixins: [ DocumentoMixin, FormMixin, StepMixin ],   
    directives: { mask },  
    data(){
        return {
            rules:{
                documento: [
                    val => {
                        if((val || null) == null)
                            return this.txtDocumentoObrigatorio;

                        return true;
                    }
                ],                               
                primeiroNome: [
                    val => {
                        if((val || null) == null)
                            return this.txtPrimeiroNomeObrigatorio;

                        return true;
                    }
                ],
                ultimoNome: [
                    val => {
                        if((val || null) == null)
                            return this.txtUltimoNomeObrigatorio;

                        return true;
                    }
                ],
            },
        }
    },
    computed: { 
        labelDocumento () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.documento-identificacao');
        },               
        txtDocumentoObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.documento-obrigatorio');
        },
        mascaraDocumento(){
            if(this.value == null || this.value.pais == null)
                return "";
            
            else{
                return this.retornarMascaraDocumentoPrincipal(this.value.pais);
            }
        },        
        documento:{
            get(){
                const documento = this.getCodigoUnicoNaLista(OnboardingConstantes.dadosColaborador.DOCUMENTO);
                if(documento != null){
                    const atributo = this.getValorAtributo(documento);

                    if(atributo != null){
                        if((atributo.listaValores == true && atributo.valor != null) || (atributo.listaValores == false && this.$_.trim(atributo.valor) != "")){
                            if(atributo.readonly || this.$route.params.id != null){
                                return this.formatarDocumentoPrincipal(this.value.pais, atributo.valor);
                            }
                            else{
                                return atributo.valor;
                            }
                        }
                        else 
                            return null;
                    }
                    else
                        return null;
                }
                
                return null;
            },
            set(value){
                const documento = this.getCodigoUnicoNaLista(OnboardingConstantes.dadosColaborador.DOCUMENTO);
                if(documento != null){
                    const atributo = this.getValorAtributo(documento);

                    if(atributo != null){
                        let onboarding = this.$_.clone(this.value);
                        onboarding.atributo[atributo.index].valor = value;
                    }
                }
            }
        },              
        labelPrimeiroNome () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.primeiro-nome');
        },        
        txtPrimeiroNomeObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.primeiro-nome-obrigatorio');
        },                 
        primeiroNome:{
            get(){
                const atributo = this.getValorAtributo(OnboardingConstantes.dadosColaborador.PRIMEIRO_NOME);
                if(atributo != null){
                    if((atributo.listaValores == true && atributo.valor != null) || (atributo.listaValores == false && this.$_.trim(atributo.valor) != ""))
                        return atributo.valor;

                    else 
                        return null;
                }
                else
                    return null;
            },
            set(value){
                const atributo = this.getValorAtributo(OnboardingConstantes.dadosColaborador.PRIMEIRO_NOME);
                if(atributo != null){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.atributo[atributo.index].valor = value;
                }
            }
        },                  
        labelUltimoNome () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.ultimo-nome');
        },           
        txtUltimoNomeObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.ultimo-nome-obrigatorio');
        },  
        ultimoNome:{
            get(){
                const atributo = this.getValorAtributo(OnboardingConstantes.dadosColaborador.ULTIMO_NOME);
                if(atributo != null){
                    if((atributo.listaValores == true && atributo.valor != null) || (atributo.listaValores == false && this.$_.trim(atributo.valor) != ""))
                        return atributo.valor;
                    else 
                        return null;
                }
                else
                    return null;
            },
            set(value){
                const atributo = this.getValorAtributo(OnboardingConstantes.dadosColaborador.ULTIMO_NOME);
                if(atributo != null){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.atributo[atributo.index].valor = value;
                }
            }
        },                                                                           
    },
    methods:{
        txtPrimeiroNome_OnChange(val){
            let onboarding = this.$_.clone(this.value);
            onboarding.primeiroNomeAlterado = val;
            this.$emit("input", onboarding);
        },
        txtUltimoNome_OnChange(val){
            let onboarding = this.$_.clone(this.value);
            onboarding.ultimoNomeAlterado = val;
            this.$emit("input", onboarding);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/material-dashboard/variables";

</style>
